import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedProjectId:[]
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    selectdProject: (state, action) => {
      if (state.selectedProjectId.includes(action.payload)) {
        const index = state.selectedProjectId.indexOf(action.payload);
        state.selectedProjectId.splice(index, 1);
      } else {
        state.selectedProjectId.push(action.payload);
      }
    }
  }
});

export const { selectdProject } = projectSlice.actions;
export default projectSlice.reducer;

